jQuery(function($){
	$('.store-filters .store-filter-type--choice-list input[type="checkbox"]').on('change', function(){
		console.log('happened');
		const parentDiv = $(this).closest('.store-filter');
		const checkboxes = parentDiv.find('input[type="checkbox"]');

		let hasChoices = false;
		let numChoices = 0;
		checkboxes.each(function(){
			if(this.checked) {
				hasChoices = true;
				numChoices++;
			}
		});

		parentDiv.find('.filter-badge').html(numChoices);

		if(hasChoices) {
			parentDiv.addClass('populated');
		} else {
			parentDiv.removeClass('populated');
		}

		updateTotalFilters(parentDiv);
	});

	$('.store-filters .store-filter-type--choice-list .clear-filters').on('click', function(){
		const parentDiv = $(this).closest('.store-filter');
		const checkboxes = parentDiv.find('input[type="checkbox"]');

		checkboxes.each(function(){
			this.checked = false;
		});

		parentDiv.find('.filter-badge').html(0);

		parentDiv.removeClass('populated');
		
		updateTotalFilters(parentDiv);
	});

	$('.store-filters .store-filter-type--true-false input[type="checkbox"]').on('change', function(){
		const parentDiv = $(this).closest('.store-filter');
		
		if(this.checked) {
			parentDiv.addClass('populated');
			parentDiv.find('.filter-badge').html('<span class="fas fa-check"></span>');
		} else {
			parentDiv.removeClass('populated');
			parentDiv.find('.filter-badge').html('');
		}
		
		updateTotalFilters(parentDiv);
	});

	$('.store-filter .store-filter-label').on('click', function(){
		const parentDiv = $(this).closest('.store-filter');
		const wasExpanded = parentDiv.hasClass('expanded');

		parentDiv.closest('.store-filter-wrapper').find('.store-filter').removeClass('expanded');
		if(!wasExpanded) parentDiv.addClass('expanded');
	});

	$('.store-filters .store-filter-tab').on('click', function(){
		const parentDiv = $(this).closest('.store-filters');
		parentDiv.toggleClass('show-filters');
		$(this).closest('.store-filters').find('.store-filter').removeClass('expanded');
	});

	$('.store-filter-type--typeahead .typeahead-value').on('change', function(){
		const parentDiv = $(this).closest('.store-filter');
		console.log('changed');

		const value = $(this).val();
		const valueJson = JSON.parse(value);

		if(valueJson.length) {
			parentDiv.addClass('populated');
			parentDiv.find('.filter-badge').html(valueJson.length);
		} else {
			parentDiv.removeClass('populated');
			parentDiv.find('.filter-badge').html('');
		}

		setTimeout(function(){
			updateTotalFilters(parentDiv);
		}, 150);
	});

	$('.store-filters input[name="keyword"]').on('keyup', function(){
		updateTotalFilters($(this));
	});

	$('.store-filters .clear-all-filters').on('click', function(){
		const parentForm = $(this).closest('form');
		
		//Keyword
		parentForm.find('input[name="keyword"]').val('');

		//Checkboxes
		parentForm.find('input[type="checkbox"]').each(function(){
			this.checked = false;
			$(this).trigger('change');
		});

		//Typeahead Fields
		parentForm.find('.store-filter-type--typeahead .typeahead-value').each(function(){
			$(this).val('[]').trigger('change');
			$(this).closest('.value').find('.selected').html('');
		});

		parentForm.find('.store-filter').removeClass('expanded');

		parentForm.submit();
	});

	function updateTotalFilters(el) {
		const filterParent = el.closest('.store-filters');
		const filters = filterParent.find('.store-filter');
		const clearFilters = filterParent.find('.clear-all-filters-wrapper');
		const totalFilters = filterParent.find('.store-filter-tab .total-filters');

		let filterNumber = 0;
		filters.each(function(){
			if($(this).hasClass('populated')) {
				if($(this).hasClass('true-false') || $(this).hasClass('choice-list')) {
					const checkedBoxes = $(this).find('input[type="checkbox"]:checked').length;
					filterNumber += checkedBoxes;
				}
				if($(this).hasClass('typeahead')) {
					const typeaheadResults = $(this).find('.value .selected .result').length;
					filterNumber += typeaheadResults;
				}
			}
		});

		const hasKeyword = filterParent.find('input[name="keyword"]').val().length;

		if(filterNumber || hasKeyword) {
			clearFilters.css('display', 'flex');
		} else {
			clearFilters.hide();
		}

		if(filterNumber) {
			totalFilters.html(filterNumber).css('display', 'flex');
		} else {
			totalFilters.html(filterNumber).hide();
		}
	}

	if($('.store-filters').length) {
		$('.store-filters').each(function(){
			updateTotalFilters($(this));
		})
	}

	$('form#cs-store-filters').on('submit', function(e){
		$(this).addClass('searching');
	});

	$('.active-filter--clear').on('click', function(){
		if(!$(this).hasClass('not-clickable')) {
			$('.active-filter--clear').addClass('not-clickable');

			const clearTarget = $(this).attr('clear_target');
			const form = $(this).closest('form');
			const activeFilter = $(this).closest('.active-filter');
			const clearTargetEl = form.find(clearTarget)

			if(clearTarget == '[name=keyword]') {
				clearTargetEl.val('');
			} else {
				clearTargetEl.trigger('click');
			}

			activeFilter.remove();
			form.submit();
		}
	});
});